document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Cart Drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var openTriggers = document.querySelectorAll('[data-cart-open]');
  var closeTriggers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openTriggers.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  closeTriggers.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); }); });
  if (overlay) overlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    fetch('/cart')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && drawer) drawer.innerHTML = newDrawer.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          refreshCartDrawer();
          openCart();
        })
        .catch(function (err) { console.error('Add to cart error', err); })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
        });
    });
  });

  /* ---------- Cart line quantity update ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    var input = document.querySelector('[data-qty-input="' + key + '"]');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var newQty = Math.max(0, parseInt(input.value, 10) + delta);
    input.value = newQty;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function () { refreshCartDrawer(); window.location.reload(); })
      .catch(function (err) { console.error('Cart update error', err); });
  });

  /* ---------- Product quantity selector (form) ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-dir');
        var val = parseInt(input.value, 10) || 1;
        input.value = dir === 'inc' ? val + 1 : Math.max(1, val - 1);
      });
    });
  });

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('[data-gallery-main]');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    });
  });

});
